import {
  TmElement,
  border,
  color,
  rem,
  reset,
} from '@thiememeulenhoff/lit-sdk';
import { css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tagName } from '../../../helpers';

const tag = tagName('header-item');

@customElement(tag)
export class HeaderItemComponent extends TmElement {
  static override styles = [
    reset.a,
    css`
      :host {
        align-items: center;
        block-size: 100%;
        cursor: pointer;
        display: flex;
        padding: ${rem(0, 8)};
      }

      :host(:hover) {
        background: ${color('neutral', 100)};
      }

      :host([active]) {
        background: ${color('neutral', 200)};
        border-block-end: ${border(3, 'neutral', 800, 'solid')};
        border-block-start: ${rem(3)} solid hsla(0, 0%, 0%, 0);
      }
    `,
  ];

  @property({ type: String, reflect: true })
  href?: string;

  @property({ type: Boolean, reflect: true })
  active = false;

  override render() {
    return html`<a href="${this.href ?? nothing}"><slot></slot></a>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-header-item': HeaderItemComponent;
  }
}
